import { render, staticRenderFns } from "./CampaignDetailsSummary.vue?vue&type=template&id=6c567a2c&scoped=true"
import script from "./CampaignDetailsSummary.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsSummary.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsSummary.vue?vue&type=style&index=0&id=6c567a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c567a2c",
  null
  
)

export default component.exports